import React from "react";
import logo from "../../assets/echovibe.png";
import aibg from "../../assets/aibg.png";

export default function AuthLayout({ children }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 py-10">
      <div
        className="pointer-events-none fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${aibg})` }}
        aria-hidden
      />
      <div
        className="pointer-events-none fixed inset-0 z-[1] bg-white/25 backdrop-blur-[1px]"
        aria-hidden
      />
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white/65 p-6 shadow-xl backdrop-blur-sm md:p-8">
        <div className="flex justify-center py-6">
          <img src={logo} alt="Logo" width="165" />
        </div>
        {children}
      </div>
    </div>
  );
}
